module.exports = __webpack_public_path__ + "media/images/athletes/998-adf039a3478e0e8849cefa0b0c29e075.png";